import React from 'react';
import './premium-ui.css';

export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="cm-page-header">
    <div>
      {eyebrow && <span className="cm-page-eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
    {actions && <div className="cm-page-actions">{actions}</div>}
  </div>
);

export const StatisticCard = ({
  title,
  value,
  icon,
  tone = 'green',
  helper,
  trend,
  children
}) => (
  <article className={`cm-stat-card cm-stat-${tone}`}>
    <div className="cm-stat-top">
      <span>{title}</span>
      <div className="cm-stat-icon">{icon}</div>
    </div>
    <div className="cm-stat-value">{value}</div>
    <div className="cm-stat-footer">
      <span>{helper}</span>
      {trend && <strong>{trend}</strong>}
    </div>
    {children}
  </article>
);

export const ChartCard = ({ title, subtitle, actions, children }) => (
  <section className="cm-chart-card">
    <div className="cm-card-heading">
      <div>
        <h3>{title}</h3>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div>{actions}</div>}
    </div>
    <div className="cm-chart-body">{children}</div>
  </section>
);

export const AlertCard = ({ priority = 'info', title, description, icon }) => (
  <div className={`cm-alert-card cm-alert-${priority}`}>
    <div className="cm-alert-icon">{icon}</div>
    <div>
      <strong>{title}</strong>
      <p>{description}</p>
    </div>
  </div>
);

export const StatusBadge = ({ tone = 'neutral', children }) => (
  <span className={`cm-status-badge cm-badge-${tone}`}>{children}</span>
);
